import styled from '@emotion/styled';

/** hero 카피(z-index 1) 위 — 작은 단풍 전용 레이어 */
export const MapleFrontLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
`;
